var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "105.82mm",
    height: "122mm",
    viewBox: "0 0 105.82 122",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 1.3825,
    y: 1.686,
    width: 103.03,
    height: 118.93,
    ry: 7.157,
    fillOpacity: 0,
    stroke: "#840000",
    strokeLinecap: "round",
    strokeOpacity: 0.45078,
    strokeWidth: 1.464,
    style: {
      mixBlendMode: "multiply"
    }
  }), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\ntext {\n\tfont-family: sans-serif;\n\tfont-size: 102pt;\n\ttext-anchor: middle;\n}\n\nline {\n\tstroke: #000;\n\tstroke-width: 9px;\n}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.14005 0 0 .14005 21.716 61.364)",
    strokeWidth: 12.424
  }, /*#__PURE__*/React.createElement("line", {
    x1: 151.95,
    x2: 11.949,
    y1: -57.647,
    y2: 62.353,
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.51,
    x2: 433.51,
    y1: -57.647,
    y2: 62.353,
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.17-81.149c0-15.811 4.2497-28.191 12.739-37.136 8.4942-8.9448 19.456-13.415 32.886-13.415 8.7963 0 16.727 2.0992 23.788 6.2977 7.0606 4.2036 12.447 10.061 16.149 17.577 3.7018 7.5163 5.5553 16.041 5.5553 25.565 0 9.6616-1.9508 18.304-5.8523 25.923-3.9015 7.6238-9.421 13.394-16.569 17.316-7.1476 3.922-14.864 5.8779-23.143 5.8779-8.9704 0-16.983-2.1658-24.044-6.4974-7.0657-4.3367-12.416-10.245-16.057-17.741-3.6353-7.4856-5.4529-15.406-5.4529-23.767zm13.041 0.19995c0 11.469 3.0874 20.506 9.252 27.111 6.1697 6.5998 13.906 9.9022 23.204 9.9022 9.4824 0 17.28-3.3281 23.399-9.9995 6.1236-6.6663 9.1854-16.123 9.1854-28.375 0-7.7467-1.3107-14.51-3.9271-20.291-2.6215-5.7806-6.4513-10.261-11.489-13.445-5.0382-3.1796-10.701-4.7719-16.973-4.7719-8.9141 0-16.584 3.0669-23.01 9.1906-6.4257 6.1236-9.6411 16.348-9.6411 30.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m466.94 133.01v-95.28h12.641v39.123h49.44v-39.123h12.641v95.28h-12.641v-44.878h-49.44v44.883h-12.641v-5e-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-96.195 133.17v-95.28h12.641v39.123h49.44v-39.123h12.641v95.28h-12.641v-44.878h-49.44v44.883h-12.641v-5e-3z"
  }))), /*#__PURE__*/React.createElement("path", {
    transform: "scale(.26458)",
    d: "m88.968 264.27c-1.2212-1.976-0.22396-2.9096 38.059-35.631 17.846-15.254 33.068-27.528 33.828-27.276 0.7594 0.25176 1.3807 1.1344 1.3807 1.9613 0 1.3475-70.141 62.47-71.687 62.47-0.35085 0-1.0618-0.68594-1.58-1.5243z",
    fillOpacity: 0,
    style: {
      mixBlendMode: "soft-light",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(.26458)",
    d: "m191.92 212.33c-12.409-4.6626-18.653-21.177-13.064-34.551 4.1523-9.9378 10.933-14.451 21.589-14.368 13.519 0.10472 22.53 9.8568 22.521 24.373-7e-3 10.616-3.7832 18.21-11.146 22.414-5.2124 2.9763-14.893 4.014-19.899 2.1331zm16.746-5.3086c4.6924-2.4266 9.4145-11.35 9.45-17.858 0.0703-12.865-6.8938-21.401-17.459-21.401-12.07 0-18.402 7.247-18.402 21.061 0 15.848 13.272 24.993 26.411 18.199z",
    fillOpacity: 0,
    style: {
      mixBlendMode: "soft-light",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(.26458)",
    d: "m272.63 235.6c-20.131-17.251-36.65-31.489-36.709-31.64-0.11273-0.28962 3.3315-4.5382 3.6788-4.5379 0.36286 2.6e-4 73.406 62.738 73.406 63.05 0 0.33981-3.2898 4.4471-3.5847 4.4755-0.10377 0.01-16.66-14.096-36.791-31.347z",
    fillOpacity: 0,
    style: {
      mixBlendMode: "soft-light",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(.26458)",
    d: "m329.42 277.16v-24.904h6.4148v20.376h26.414v-20.376h6.4148v49.809h-6.4148v-23.772h-26.414v23.772h-6.4148z",
    fillOpacity: 0,
    style: {
      mixBlendMode: "soft-light",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(.26458)",
    d: "m31.319 277.16v-24.904h6.4148v20.754h26.414v-20.754h6.4148v49.809h-6.404l-0.09971-11.792-0.09971-11.792-26.225-0.1984v23.782h-6.4148z",
    fillOpacity: 0,
    style: {
      mixBlendMode: "soft-light",
      paintOrder: "markers stroke fill"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.328cfa05b7fbf2b5b38e4b21ec059c64.svg";
export { ForwardRef as ReactComponent };